import { NavLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { Asset } from "../../../../models/asset";

import "../styles.scss";

interface IScheduleModalProps {
  asset: Asset | null;
  isOpen: boolean;
  onClose: () => void;
}

const ToScheduleDialog = ({ asset, isOpen, onClose }: IScheduleModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="scheduleModal">
      <div className="bg-white shadow-lg scheduleModal__wrapper">
        <div className="flex justify-between items-center border-b scheduleModal__header">
          <h2 className="text-size-20 font-normal m-0 p-0">
            <FormattedMessage id="intl-msg:monitoring.schedule.title" />
          </h2>
          <button
            onClick={onClose}
            className="text-color-black text-size-h2 hover:text-gray-800"
          >
            &times;
          </button>
        </div>

        <div className="flex flex-column gap-6 scheduleBody">
          {!asset?.volksTotalPlan && <div className="border scheduleBody__card">
            <h3 className="text-center text-size-h2 font-medium">
              <span className="font-bold text-color-info">Volks</span>
              <span className="text-color-status-resting"> | Total</span>
            </h3>
            <p className="text-center text-size-16 text-color-black mt-2 margin-bottom-20">
              <FormattedMessage id="intl-msg:monitoring.schedule.volksTotal" />
            </p>
            <button className="btn btn-primary text-size-16">
              <FormattedMessage id="intl-msg:monitoring.schedule.continue" />
            </button>
          </div>}

          <div className="border scheduleBody__card">
            <div className="flex justify-center margin-bottom-10">
              <span className="rioglyph rioglyph-workshop text-size-h1"></span>
            </div>
            <p className="text-center text-size-16 text-color-black mt-2 margin-bottom-20">
              <FormattedMessage id="intl-msg:monitoring.schedule.simple" />
            </p>
            <button className="btn btn-primary text-size-16 btn-scheduling">
              <NavLink to={`/control-tower/appointments/appointment?asset=${asset?.id}&chassis=${asset?.chassis}&name=${asset?.name || asset?.model}`}>
                <FormattedMessage id="intl-msg:monitoring.schedule.continue" />
              </NavLink>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToScheduleDialog;
